import React from "react";
import DMModuleSubtopic from "../DMModuleSubtopic";

const Poset = () => (
  <DMModuleSubtopic
    title="POSET"
    videos={[
      "https://www.youtube.com/embed/_MvUUNve6l4?list=PLXj4XH7LcRfBB-4hXp4XI84HOCWkaBD63",
      "https://www.youtube.com/embed/GpBfvE5zFJY?list=PLXj4XH7LcRfBB-4hXp4XI84HOCWkaBD63",
      "https://www.youtube.com/embed/eTT-W_9rT2Q?list=PLXj4XH7LcRfBB-4hXp4XI84HOCWkaBD63",
      "https://www.youtube.com/embed/AJQhNSno9Bg",
      "https://www.youtube.com/embed/q4iHIAZUfCQ",
      "https://www.youtube.com/embed/YAFVEyAZVqQ"

    ]}
    takeaways={[]}
    questions={[
      {
        text: "Let n=60 and X be the set of all positive integers which are divisors of 60. Let '≤' be the relation 'divisor of' on X (i) Draw the Hasse Diagram <X,≤> (ii) Find the lub and glb of (2,5) and (12,30) (iii) What is the greatest and least element of <X,≤>"
      },
      {
        text: "Draw the Hasse Diagram for Poset <{2,4,6,9,12,18,27,36,48,60,72},divides>. Find the minimal and maximal elements, least and greatest elements, upper bounds and lub of (2,9) , lower bounds and glb of (60,72)"
      },
      {
        text: "Find whether the relation R={(x,y):y is a multiple of x} defined on set of all integers is a partial ordering"
      },
      {
        text: "Draw the Hasse diagram of {1,2,3} x {1,2,3} with the Lattice order (a,b) ≤ (x,y) iff 'a≤x and b≤y'"
      },
      {image:"/dm_20.png"},
      {image:"/dm_21.png"}
    ]}
    exampleVideos={[]}
  />
);

export default Poset;
